export const JobStatuses = {
  1: 'Waiting For Approval',
  2: 'Scheduled',
  3: 'Completed',
  5: 'Canceled',
  7: 'Lost',
};
